export const monthNames = [["ตุลาคม", 10],["พฤศจิกายน",11],["ธันวาคม",12],["มกราคม",1],["กุมภาพันธ์",2],["มีนาคม",3],["เมษายน",4],["พฤษภาคม",5],["มิถุนายน",6],["กรกฎาคม",7],["สิงหาคม",8],["กันยายน",9]];

export const leaveType = [1, 2, 66, 77, 12, 4, 13, 3, 9, 10, 8, 7, 6, 11];

export const isInBudgetYear = (y, m, d, budYear) => {
  const christYear = Number(budYear) - 543;
  const start = new Date(christYear - 1, 9, 1);
  const end = new Date(christYear, 8, 30, 23, 59, 59);
  const dt = new Date(y, m - 1, d);
  return dt >= start && dt <= end;
};

export const isWeekend = (date) => {
  const day = new Date(date)?.getDay();
  return day === 6 || day === 0;
};

export const isThaiHoliday = (date, holiday) => {
  const localDate = new Date(date);
  localDate.setHours(0, 0, 0, 0);
  return holiday?.some((item) => {
    const startDate = new Date(item?.date_start_holiday)?.setHours(0, 0, 0, 0);
    const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
    return localDate >= startDate && localDate <= endDate;
  });
};

export const calHalfData = (data) => {
  const firstRange = [10, 11, 12, 1, 2, 3];
  const secondRange = [4, 5, 6, 7, 8, 9];

  const sumMaxByMonth = (range) => {
    const maxByMonth = data
      .filter((item) => range.includes(item.month))
      .reduce((acc, item) => {
        if (!acc[item.month] || item.count > acc[item.month]) {
          acc[item.month] = item.count;
        }
        return acc;
      }, {});
    return Object.values(maxByMonth).reduce((sum, c) => sum + c, 0);
  };

  return {
    firstRange: [{ count: sumMaxByMonth(firstRange) }],
    secondRange: [{ count: sumMaxByMonth(secondRange) }],
  };
};